import type { FC } from "react";
import { StyledComponent } from "styled-components";

export const keyArea = Symbol("area");

export type Name = string;

export type AreaComponent = StyledComponent<FC, any> & {
  [keyArea]?: Name | FC["displayName"];
};

export type Area = (Component: FC, name?: Name) => AreaComponent;
